import { Box, Typography, useTheme } from "@mui/material"
import { IoCubeOutline } from "react-icons/io5"
import { getCenterStyles, getFluidBoxStyles } from "vig-ui-library"

export type DataNotFoundProps = {
    title: string;
    description: string;
}

export const DataNotFound = (props: DataNotFoundProps) => {
    const theme = useTheme();

    return <Box sx={{ ...getFluidBoxStyles(), ...getCenterStyles("column"), padding: 2, gap: 1, textAlign: "center" }}>
        <IoCubeOutline size={32} color={theme.palette.grey[600]} />
        <Typography variant="h6">{props.title}</Typography>
        <Typography variant="body2">{props.description}</Typography>
    </Box>
}